import React from 'react';
import {
  DataGrid,
  GridCellParams,
  GridColumns,
  GridRowId,
} from '@material-ui/data-grid';
import { TableContainer, NavButton } from './styles';
import { useQuitacao } from '../../QuitacaoContext';
import moment from 'moment';
import { createDateWithoutTimezone } from '~/utils/createDateWithoutTimezone ';
import { InputCheckbox } from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import { Parcela } from '../../protocols';

export const TableTitulos: React.FC = () => {
  const {
    parcelas,
    onChangeParcelas,
    formTela: { register },

    loadingTableTitulos,
  } = useQuitacao();

  const columns: GridColumns = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'flg_check',
      headerName: ' ',
      sortable: false,
      width: 30,
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: (params: GridCellParams) => {
        const { row } = params;
        const { flg_check } = row;
        return (
          <InputCheckbox
            name="flg_check"
            checked={flg_check}
            register={register}
            isError={false}
            onClick={() => {
              onSelectedParcela('SINGLE', !flg_check, row.id);
            }}
            style={{ margin: '15px' }}
          />
        );
      },
    },
    {
      field: 'cod_loja',
      headerName: 'Loja',
      width: 100,
      disableColumnMenu: true,
      align: 'right',
    },
    {
      field: 'num_docto',
      headerName: 'Docto',
      width: 120,
    },
    {
      field: 'nome_pessoa',
      headerName: 'Parceiro',
      flex: 1,
      minWidth: 220,
    },
    {
      field: 'cod_finalizadora',
      headerName: 'Finalizadora',
      minWidth: 220,
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const { row } = params;
        return <>{row.des_finalizadora}</>;
      },
    },
    {
      field: 'val_parcela',
      headerName: 'Valor',
      width: 120,
      align: 'right',
      renderCell: (params) => {
        const { row } = params;
        return (
          <div>
            {row.val_parcela
              .toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
              .replace(/^(\D+)/, '')}
          </div>
        );
      },
    },
    {
      field: 'val_juros',
      headerName: 'Juros',
      width: 110,
      align: 'right',
      renderCell: (params) => {
        const { row } = params;
        return (
          <div>
            {row.val_juros
              .toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
              .replace(/^(\D+)/, '')}
          </div>
        );
      },
    },
    {
      field: 'dta_entrada',
      headerName: 'Entrada',
      width: 160,
      renderCell: (params) => {
        const { row } = params;
        return (
          <>
            {moment(
              createDateWithoutTimezone(row.dta_entrada),
              'YYYY-MM-DD',
            ).format('DD/MM/YYYY')}
          </>
        );
      },
    },
    {
      field: 'dta_vencimento',
      headerName: 'Vencimento',
      width: 160,
      renderCell: (params) => {
        const { row } = params;
        return (
          <>
            {moment(
              createDateWithoutTimezone(row.dta_vencimento),
              'YYYY-MM-DD',
            ).format('DD/MM/YYYY')}
          </>
        );
      },
    },
  ];

  const onSelectedParcela = (
    type: string,
    check: boolean,
    selected?: GridRowId,
  ) => {
    const updateParcela = (parcela: Parcela) =>
      type === 'SINGLE' && parcela.id === selected
        ? { ...parcela, flg_check: check }
        : type === 'ALL'
        ? { ...parcela, flg_check: check }
        : parcela;

    const selectedParcelas = parcelas.map(updateParcela);

    onChangeParcelas(selectedParcelas);
  };

  return (
    <>
      <Separator childrenWidth="220px">
        <div style={{ display: 'flex' }}>
          <NavButton
            type="button"
            style={{
              marginTop: '-7px',
            }}
            onClick={() => onSelectedParcela('ALL', false)}
          >
            Desmarcar Todos
          </NavButton>{' '}
          |
          <NavButton
            type="button"
            style={{
              marginTop: '-7px',
            }}
            onClick={() => onSelectedParcela('ALL', true)}
          >
            Marcar Todos{' '}
          </NavButton>
        </div>
      </Separator>
      <TableContainer>
        <DataGrid
          rows={parcelas}
          columns={columns}
          pageSize={5}
          loading={loadingTableTitulos}
          hideFooterSelectedRowCount={
            parcelas.filter((p) => p.flg_check).length <= 0
          }
          localeText={{
            noRowsLabel: 'Nenhum registro encontrado...',
            columnMenuLabel: 'Menu',
            columnMenuFilter: 'Filtrar',
            columnMenuHideColumn: 'Esconder',
            columnMenuUnsort: 'Não ordenar',
            columnMenuSortAsc: 'Ordernar ASC',
            columnMenuSortDesc: 'Ordernar DESC',
            columnMenuShowColumns: 'Mostrar columnas',
            footerRowSelected: () => {
              const checkedCount = parcelas.filter((p) => p.flg_check).length;
              return checkedCount > 1
                ? `${checkedCount.toLocaleString()} linhas selecionadas`
                : `${checkedCount.toLocaleString()} linha selecionada`;
            },
          }}
        />
      </TableContainer>
    </>
  );
};
